'use strict';

var React = require('react');

var SvgDuplicateMinor = function SvgDuplicateMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M8.75 8.5a.75.75 0 0 1 .75.75v1.25h1.25a.75.75 0 0 1 0 1.5h-1.25v1.25a.75.75 0 0 1-1.5 0v-1.25h-1.25a.75.75 0 0 1 0-1.5h1.25v-1.25a.75.75 0 0 1 .75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8.75 3.5a2.75 2.75 0 0 0-2.74 2.51 2.75 2.75 0 0 0-2.51 2.74v5a2.75 2.75 0 0 0 2.75 2.75h5a2.75 2.75 0 0 0 2.74-2.51 2.75 2.75 0 0 0 2.51-2.74v-5a2.75 2.75 0 0 0-2.75-2.75h-5Zm2.5 2.5h-3.725c.116-.57.62-1 1.225-1h5c.69 0 1.25.56 1.25 1.25v5c0 .605-.43 1.11-1 1.225v-3.725a2.75 2.75 0 0 0-2.75-2.75Zm-5 1.5c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h5c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25h-5Z"
  }));
};
SvgDuplicateMinor.displayName = "DuplicateMinor";

exports.SvgDuplicateMinor = SvgDuplicateMinor;
